import { createReducer, on } from '@ngrx/store';
import { loadUserProfileFailure, loadUserProfileSuccess, updateUserProfileSuccess } from '@/store/current-user/profile.actions';
import { CurrentUserState } from './current-user.model';
import { loadCurrentUserTeams, loadCurrentUserTeamsFailure, loadCurrentUserTeamsSuccess } from './teams.actions';

export const initialMyProfileState: CurrentUserState = {
  currentUser: null,
  profileLoaded: false,
  teams: [],
  teamsLoaded: false,
  loading: false,
  error: null,
};

export const currentUserState = createReducer(
  initialMyProfileState,
  on(loadUserProfileSuccess, (state, { userProfile, currentUser }) => ({
    ...state,
    currentUser: userProfile || currentUser, // Use userProfile if available, fallback to currentUser
    profileLoaded: true,
  })),
  // Settle the flag even on failure so role guards deny cleanly instead of
  // waiting on a profile that will never arrive.
  on(loadUserProfileFailure, (state) => ({
    ...state,
    profileLoaded: true,
  })),
  on(updateUserProfileSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(loadCurrentUserTeams, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadCurrentUserTeamsSuccess, (state, { teams }) => ({
    ...state,
    teams,
    teamsLoaded: true,
    loading: false,
  })),
  on(loadCurrentUserTeamsFailure, (state, { error }) => ({
    ...state,
    error,
    // Settle the flag even on failure so guards fall back to "no enabled
    // teams" instead of hanging on a load that will never succeed.
    teamsLoaded: true,
    loading: false,
  }))
);
